import {
  PropsWithChildren, createContext, useContext, useMemo,
} from 'react';
import { defaultGuid } from '@equifinance/shared';
import {
  Notes,
  useNotes,
} from '.';

export type NotesContextType = {
  id: string,
  notes: Notes,
}

export const defaultNotes: Notes = {
  updateCount: 0,
  id: defaultGuid,
  errors: {},
  warnings: {},

  product: {
    id: defaultGuid,
    underwriterSelectedProduct: {
      id: defaultGuid,
      productCode: '',
    },
    justification: '',
    authorisedById: defaultGuid,
    authorisedByName: '',
  },
};

const defaultNotesContext: NotesContextType = {
  id: defaultGuid,
  notes: defaultNotes,
};

export const NotesContext = createContext<NotesContextType>(defaultNotesContext);

export function useNotesContext() {
  return useContext(NotesContext);
}

export function NotesProvider({ id, children }: PropsWithChildren<{id: string}>) {
  const notes = useNotes(id);

  const contextValue = useMemo(() => ({ ...notes, id }), [id, notes]);

  return (
    <NotesContext.Provider value={contextValue}>{children}</NotesContext.Provider>
  );
}
